import React, { memo, useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, openModal } from '../../store/actions/modalAction';
// import CreateQueryController from './CreateQueryController';
import { deleteQueryApi } from '../../apis/query.api';
import { QUERY_STATUS, REPAIRING_STATUS, SEND_STATUS, SNACK_BAR_VARIETNS, USER_ROLES } from '../../utils/constants';
import MessageDilog from "../../components/texts/MessageDilog";
import { Box, Button, IconButton, Typography } from '@mui/material';
import { Delete, Edit } from '@mui/icons-material';
import { fetchQueryAction, fetchQueryCountAction } from '../../store/actions/queryAction';
import { callApiAction } from '../../store/actions/commonAction';
import { callSnackBar } from '../../store/actions/snackbarAction';
import { findObjectKeyByValue, titleCase } from '../../utils/main';
// import StatusController from './StatusController';
import RepairUi from './RepairUi';
import moment from 'moment';
import CustomerInformation from './CustomerInformation';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { FetchRepairDataCountApi } from '../../apis/repair.api';
const ActionComponent = memo(({ params, setParams }) => {
    const dispatch = useDispatch();
    const modalkey = "Queryupdate";
    const [loading, setLoading] = useState(false);
    const { Query } = useSelector((state) => state);
    const user = useSelector((state) => state.user);

    const onView = () => {
        dispatch(openModal(<CustomerInformation params={params} />, "lg", true, "CustomerInformation"))
    }
    return (
        <Box sx={{ width: "100%", alignItems: "flex-start", display: "flex" }}>

            <IconButton size="inherit" onClick={onView}>
                <RemoveRedEyeIcon color="info" fontSize="inherit" />
            </IconButton>

        </Box>
    );
});

const RepairController = () => {
    const { Query, user } = useSelector((state) => state);
    const [buttonStatus, setButtonStatus] = useState( REPAIRING_STATUS.ALL );
    const [countLoading, setCountLoading] = useState(false);
    const dispatch = useDispatch();
    const [selectedButtonId, setSelectedButtonId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [sendStatus , setSendStatus] = useState();
    const UpdateStatus = (id) => {
        // dispatch(openModal(<StatusController id={id} />, "md", false, "updatestatus"));
    }
    const columns = useMemo(
        () => [
            {
                id: 6,
                fieldName: "createdAt",
                label: "Created Date",
                align: "left",
                sort: true,
                renderValue: (params, setParams) => moment(params?.createdAt).format("DD/MM/YYYY")
            },
            {
                id: 2,
                fieldName: "customer_name",
                label: "Name",
                align: "left",
                sort: true,
            },
            {
                id: 3,
                fieldName: "customer_phone",
                label: "Phone",
                align: "left",
                sort: true,
            },
            {
                id: 4,
                fieldName: "customer_email",
                label: "Email",
                align: "left",
                sort: true,
            },
            {
                id: 1,
                fieldName: "box_id",
                label: "Box Id",
                align: "left",
                sort: true,

            },
            // {
            //     id: 8,
            //     fieldName: "new_box_id",
            //     label: "New Box Id",
            //     align: "left",
            //     sort: true,

            // },
            {
                id: 7,
                fieldName: "warrenty_date",
                label: "Warrenty Date",
                align: "left",
                sort: false,
                renderValue: (params, setParams) => moment(params?.warrenty_date).format("DD/MM/YYYY")
            },
            // {
            //     id: 5,
            //     fieldName: "query_status",
            //     label: "Product Type",
            //     align: "left",
            //     sort: false,
            //     renderValue: (params, setParams) => titleCase(findObjectKeyByValue(params?.query_status, QUERY_STATUS))

            // },

            {
                id: 8,
                fieldName: "",
                label: "Action",
                align: "right",
                renderValue: (params, setParams) => (
                    <ActionComponent params={params} setParams={setParams} />
                ),
            },
        ],
        [dispatch]
    );


    const [filters, setFilters] = useState({
        pageNo: 1,
        pageSize: 10,
        search: "",
        searchable: ["customer_name"],
        sort: "createdAt",
        sortDirection: -1,
        startDate: moment().startOf("day").valueOf(),
        endDate: moment().endOf("day").valueOf(),
    });

    const getQueryList = () => {
        const queryStatus = QUERY_STATUS.REPAIR;
        const repairingStatus = buttonStatus
        if (
            !Query.Query_data ||
            Query.Query_data.length === 0 ||
            JSON.stringify(filters) != JSON.stringify(Query.Query_filters) || buttonStatus 
        ) {
            dispatch(fetchQueryAction(filters, queryStatus, repairingStatus, sendStatus));
        }
    };

    useEffect(() => {
        getQueryList();
    }, [filters, buttonStatus,sendStatus]);


    const [count, setCount] = useState([]);
    const fetchCount = () => {
        setCountLoading(true);
        dispatch(
            callApiAction(
                async () => await FetchRepairDataCountApi({ sort: "repairing_status",
                    sortDirection: -1,}),
                (response) => {
                    setCount(response);
                    setCountLoading(false);
                },
                (err) => {
                    setCountLoading(false);
                }
            )
        );
    };

    useEffect(() => {
        fetchCount();
    }, [filters]);



    // const count = user.data.role === USER_ROLES.WEHEAR_ADMIN ? 
    return (
        <RepairUi
            filters={filters}
            setFilters={setFilters}
            loading={Query.Query_loading}
            list={Query.Query_data}
            columns={columns}
            countloading={countLoading}
            count={count}
            setButtonStatus={setButtonStatus}
            buttonStatus={buttonStatus}
            selectedButtonId={selectedButtonId}
            setSelectedButtonId={setSelectedButtonId}
            setSendStatus={setSendStatus}
            sendStatus={sendStatus}
        />)
}

export default RepairController